


































































































































































































































// TODO 面包屑 可点击返回（带记录功能）
import { Component, Vue, Watch } from "vue-property-decorator";
// import DetailHeader from '@/components/detailHeader.vue';
import Tab from "@/components/tab.vue";
// 此组件按需加载
const detailTrain = () => import("@/components/detail/train.vue");
const detailJudge = () => import("@/components/detail/judge.vue");
const detailCrowd = () => import("@/components/detail/crowd.vue");
const detailTeam = () => import("@/components/detail/team.vue");
const detailAuthUser = () => import("@/components/detail/authUser.vue");
const detailPkgTask = () => import("@/components/detail/pkgTask.vue");
const RealName = () => import('@/components/realName.vue');

import { detail as judgeDetail } from "@/api/task/judge";
import { detail as taskDetail } from "@/api/task/common";
import {
  helps,
  getCase,
  judgeHelps,
  pkgListByProjectId,
} from "@/api/task/common";
import { goTop, isLogin } from "@/global/utils";
import { getValidate, taskSign, getToken, validate } from "@/api/task/crowd";
import {
  DOMAIN,
  HTTPDOMAIN,
  SERVER_HOST,
  mobileProject,
} from "@/global/constants";

@Component({
  components: {
    detailCrowd,
    detailJudge,
    detailTeam,
    detailTrain,
    detailAuthUser,
    detailPkgTask,
    Tab,
    RealName
  },
})
export default class Detail extends Vue {
  private keyword: string = process.env.VUE_APP_KEYWORD;
  private currentPage = "team";
  private currentContent: string = "help";
  // 任务详情数据
  private taskData: object = {};
  // 题包排序
  private sort: object = {};
  // 任务详情数据请求锁
  private loading: boolean = false;
  // 帮助文档数据
  private helpData: object[] = [];
  // 此组件为公共详情页 根据路径判断当前详情页的任务类型 默认普通任务
  private tabsList: object[] = [
    {
      label: "帮助文档",
      value: "help",
      key: "2",
    },
    {
      label: "任务描述",
      value: "desc",
      key: "2",
    },
  ];
  // goodCase badCase
  private goodCase: string = "";
  private badCase: string = "";
  //题包
  private pkgColumns: object[] = [
    {
      title: "数据包ID",
      key: "pkg_id",
      align: "center",
      minwidth: 80,
    },
    {
      title: "数据包名称",
      key: "pkg_name",
      align: "center",
      minwidth: 80,
    },
    {
      title: "标注审核",
      align: "center",
      children: [
        {
          title: "负责人/团队",
          key: "team",
          align: "center",
          minwidth: 150,
        },
        {
          title: "标注进度",
          key: "submit_progress",
          sortable: "custom",
          align: "center",
          minwidth: 124,
        },
        {
          title: "审核进度",
          key: "check_progress",
          align: "center",
          sortable: "custom",
          minwidth: 124,
        },
      ],
    },
    {
      title: "质检",
      align: "center",
      children: [
        {
          title: "负责人/团队",
          key: "inspect",
          align: "center",
          minwidth: 124,
          slot: 'inspect'
        },
        {
          title: "进度",
          key: "inspect_progress",
          align: "center",
          sortable: "custom",
          minwidth: 124,
        },
      ],
    },
    {
      title: "操作",
      slot: "operate",
      align: "center",
      minwidth: 260,
    },
  ];
  private progressList = [
    {
      value: "",
      label: "全部",
    },
    {
      value: "1",
      label: "进行中",
    },
    {
      value: "2",
      label: "已完成（质检100%）",
    },
  ];
  private searchParams: object = {
    pkg_name: "",
    group: "",
    pid: "",
    mid: "",
    page: "1",
    pagesize: "10",
    progress: "",
  };
  private pkgList: object[] = [];
  private total: number | string = 0;
  // 龙猫协议url 名称 modal check
  private agreementUrl: string = "";
  private agreementName: string = `${this.keyword}协议`;
  private proVisible: boolean = false;
  private checked: boolean = false;
  // 实名认证 modal
  private realNameShow: boolean = false;
  private modualTaskType = Object.freeze({
    1: 51,
    2: 52,
    3: 53,
    4: 54,
    5: 55,
    6: 56,
    7: 57,
    9: 52,
    10: 55,
  });

  // 实名认证信息
  private realNameMsg: string[] = [
    '该实名信息只用于平台任务及提现的法律凭证，不做其他用途',
    `一个身份证只可绑定一个${this.keyword}ID`,
    '每日认证超过5次当天将不可再认证，请认真核实后进行提交',
  ];

  @Watch("$route")
  private routechange(to: any, from: any) {
    if (to.name == "detail") {
      this.init(); // 重新加载数据
    }
  }
  private created() {
    this.init();
  }
  private init() {
    this.loading = true;
    this.currentPage = this.$route.params.page;
    goTop();
    this.getDetail();
  }
  private async getGoodCase() {
    const id = this.$route.params.id;
    const goodRes: any = await getCase({
      mid: id,
      mlid: "0",
      skip: "-1",
      auditStatus: "7",
    });
    if (goodRes && goodRes.id) {
      const from = (this.taskData as any).from;
      this.goodCase = `${DOMAIN}/tools/${from}.html?type=56&qid=${goodRes.id}&inspectmid=${id}&auditStatus=7`;
      if (from == "pointClouds") {
        this.goodCase += "&version=2";
      }
      window.open(this.goodCase);
    } else {
      this.$Notice.info({
        title: "提示",
        desc: "暂无正确标注示例数据",
      });
    }
  }
  private async getBadCase() {
    const id = this.$route.params.id;
    const badRes: any = await getCase({
      mid: id,
      mlid: "0",
      skip: "-1",
      auditStatus: "78",
    });
    if (badRes && badRes.id) {
      const from = (this.taskData as any).from;
      this.badCase = `${DOMAIN}/tools/${from}.html?type=56&qid=${badRes.id}&inspectmid=${id}&auditStatus=78`;
      if (from == "pointClouds") {
        this.badCase += "&version=2";
      }
      window.open(this.badCase);
    } else {
      this.$Notice.info({
        title: "提示",
        desc: "暂无错误标注示例数据",
      });
    }
  }

  private tableSortChange(column) {
    this.sort = column;
    this.getPkgList();
  }
  // 获取任务详情
  private async getDetail() {
    try {
      const params = { id: this.$route.params.id };
      let resp;
      if (this.currentPage == "judge") {
        resp = await judgeDetail(params);
      } else {
        resp = await taskDetail(params);
      }
      if (resp.code != "200") {
        this.$Modal.warning({
          title: resp.message,
          content: "返回列表页",
          onOk: () => {
            this.$router.go(-1); //返回上一页
          },
        });
      } else {
        this.$nextTick(() => {
          this.taskData = resp.result;
          // this.pkgList=resp.result.pkg_list;
          this.loading = false;
          this.$store.commit("setTask", resp.result);

          const taskData = this.taskData as any;
          if (taskData.team_task == 5) {
            this.getPkgList();
            let operateWidth = 260;

            if (taskData.check_list_auth) {
              operateWidth = operateWidth + 120;
            }

            Vue.set(this.pkgColumns, 4, {
              title: "操作",
              slot: "operate",
              align: "center",
              width: operateWidth,
            });
            this.pkgColumns.push();
          }

          this.getHelp();
        });
      }
    } catch (err) {
      console.log(err);
    }
  }

  private changePage(data) {
    this.searchParams = Object.assign(this.searchParams, {
      page: data,
    });
    this.getPkgList();
  }

  private async getPkgList() {
    let params: any = Object.assign({}, this.searchParams);
    try {
      const taskData = this.taskData as any;
      params.project_id = taskData.projectid;
      params.mid = taskData.id;
      if (this.sort && (this.sort as { order: string }).order !== "normal") {
        let sort: any = Object.assign({}, this.sort);
        params.key_word = sort.key;
        params.order = sort.order;
      }
      let data = await pkgListByProjectId(params);

      this.$nextTick(() => {
        const result = data as any;
        this.pkgList = result.rows;
        this.total = result.total;
      });
    } catch (err) {
      console.log(err);
    }
  }
  // 获取帮助文档
  private async getHelp() {
    try {
      const taskData = this.taskData as any;
      const params = { gid: taskData.gid };
      let data;
      if (this.currentPage === "judge") {
        data = await judgeHelps(params);
      } else {
        data = await helps(params);
      }
      this.$nextTick(() => {
        this.helpData = data as any;
      });
    } catch (err) {
      console.log(err);
    }
  }
  // 切换帮助文档、任务描述
  private changeTag(type: string) {
    this.currentContent = type;
  }
  private formatPkg(data) {
    console.log(data);
    if (data.pkg_id) {
      return data.pkg_id + ":" + data.pkg_name;
    } else {
      return "";
    }
  }
  private handlePkgSearch() {
    this.searchParams = Object.assign(this.searchParams, {
      page: "1",
    });
    this.getPkgList();
  }
  private handlePkgReset() {
    this.searchParams = {
      page: "1",
      pagesize: "20",
      group: "",
      pkg_name: "",
      progress: "",
    };
    this.getPkgList();
  }
  // 查看题包
  private handlerPkgList(row) {
    const task: any = this.taskData;
    this.$router.push({
      name: "toPkgList",
      query: { pkg_id: row.pkg_id, type: task.type },
    });
  }

  // 做题
  private async handlerStartLib(row, type) {
    console.log(row);
    console.log("做题做题做题");
    if (!isLogin(this)) {
      return;
    }
    const task: any = this.taskData;
    // 是否有做题权限: 未实名认证或未签署协议
    const res: any = await getValidate({ id: task.id });
    if (res.code === "510004") {
      this.realNameShow = true;
    } else if (res.code === "510006") {
      this.agreementUrl = task.agreementInfo ? task.agreementInfo.url : "";
      this.agreementName = task.agreementInfo
        ? task.agreementInfagreement_name
        : `${this.keyword}协议`;
      this.proVisible = true;
      this.checked = false;
    } else if (res.code === "200") {
      console.log("已经实名认证但不用签署协议或实名认证并签署协议");

      if (type === "redo") {
        this.openEditor(2, null, row.pkg_id);
      } else {
        this.openEditor(null, null, row.pkg_id);
      }
    } else {
      this.$Modal.error({
        title: "无法做题",
        content: res.message,
      });
    }
  }
  // 做题 跳转页面
  private openEditor(stage, token, pkg_id) {
    let url = `${DOMAIN}/tools/`;
    const task: any = this.taskData;

    // 移动asr项目 https无法访问 改为http访问
    if (task.id && mobileProject.indexOf(task.id * 1) > -1) {
      url = `${HTTPDOMAIN}/tools/`;
    }

    if (task.type === 7) {
      if (task.outside_url) {
        url += `platform.html?url=1&token=${token.result.token}`;
      }
    } else {
      if (/^sketch(-.+)?$/.test(task.from)) {
        const parts = task.from.split("-");
        url += `${parts.length > 1 ? parts[1] : "markPage"}.html`;
      } else if (task.from) {
        url += task.from + ".html";
      } else {
        url += "markPage.html";
      }
      url += `?type=${this.modualTaskType[task.type]}&id=${task.id}&version=2`;
      url += !stage ? "" : `&stage=${stage}`;
    }
    if (pkg_id) {
      url += `&pkg_id=${pkg_id}`;
    }
    window.open(url);
  }
  // 打开实名认证弹窗
  private openRealName() {
    this.realNameShow = true;
  }
  // 关闭实名认证弹窗
  private closeRealName() {
    this.realNameShow = false;
  }
  // 协议拒绝
  private onProtocolClose() {
    this.checked = false;
    this.proVisible = false;
    this.agreementUrl = "";
  }
  // 协议同意
  private async onProtocolOk() {
    const task: any = this.taskData;
    const res: any = await taskSign({ id: task.id });
    if (res.code === "200") {
      this.$Notice.info({
        title: "任务协议",
        desc: "签署成功!",
      });
      this.proVisible = false;
    } else {
      this.$Notice.info({ title: "提示", desc: res.message || "请求失败" });
    }
  }

  // 优先审核
  private handlerCheckFirst(pkg_id) {
    const task: any = this.taskData;
    this.$router.push({
      name: "checkfirst",
      params: { id: task.id, pkg_id: pkg_id, page: "crowd" },
    });
  }

  // 审核（只有新审核模块有此按钮）
  private handlerExamine(pkg_id) {
    const task: any = this.taskData;
    if (task.from == "partnerPage") {
      this.$router.push({
        name: "examine",
        params: { page: "crowd", id: task.id, pkg_id: pkg_id },
      });
    } else {
      this.$router.push({
        name: "examineUser",
        params: { page: "crowd", id: task.id, pkg_id: pkg_id },
      });
    }

    // if(this.$store.state.userInfo &&
    // (this.$store.state.userInfo.id == 2522490
    // || this.$store.state.userInfo.id ==3548156
    // || this.$store.state.userInfo.id ==2991095
    // || this.$store.state.userInfo.id > 3000000)){
    //     this.$router.push({
    //       name: 'examineUser',
    //       params: {page:'crowd', id: task.id,pkg_id:pkg_id},
    //     });
    // }else{
    //     this.$router.push({
    //       name: 'examine',
    //       params: {page:'crowd', id: task.id,pkg_id:pkg_id},
    //     });
    // }
  }

  // 质检
  private goTest(row) {
    if (!isLogin(this)) {
      return;
    }
    this.$router.push({
      name: "inspectPackage",
      params: {
        page: "authUser",
        id: (this.taskData as any).id,
        pkg_id: row.pkg_id,
      },
    });
  }

  private openInspect(row, index) {
    row.canInspectOpen = true
    this.$set(this.pkgList, index, row)
  }
}
